import script from "./ExamesLista.vue?vue&type=script&setup=true&lang=js"
export * from "./ExamesLista.vue?vue&type=script&setup=true&lang=js"

import "./ExamesLista.vue?vue&type=style&index=0&id=6959428a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6959428a"]])

export default __exports__